<template lang="pug">
    .range-slider-input
        el-input-number(
            size="mini"
            :value="minValue" 
            @input="changeMin"
            :max='100'
            :min='1')
        el-slider(
            :value="value"
            @input="change"
            range
            :max='100'
            :min='1'
            :marks="{ '1': '1', '100': '100' }")
        el-input-number(
            size="mini" 
            :value="maxValue"
            @input="changeMax"
            :max='100'
            :min='1')
</template>

<script>
export default {
    props: {
        value: {
            type: [Array, Object],
            default: () => []
        },
        max: {
            type: Number,
            default: 100
        },
        min: {
            type: Number,
            default: 1
        },
        marks: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        minValue() {
            return this.value[0]
        },
        maxValue() {
            return this.value[1]
        }
    },

    methods: {
        changeMin(min) {
            if (this.isAuthorizedValue(min)) {
                this.$emit('input', [min, this.maxValue])
            }
        },
        change(value) {
            this.$emit('input', value)
        },
        changeMax(max) {
            if (this.isAuthorizedValue(max)) {
                this.$emit('input', [this.minValue, max])
            }
        },
        isAuthorizedValue(val) {
            return typeof val === 'number' && val >= 1 && val <= 100
        }
    }
}
</script>
